<template>
    <div class="applocation">
        <!-- 查阅模式 -->
        <template v-if="isMode">
            <div class="app_content" v-for="item in appArray" :key="item.id" :title="item.text">
                {{ item.name }}
            </div>
        </template>
        <!-- 编辑模式 -->
        <el-transfer
            v-else
            filterable
            :titles="[$t('integration.not_applied'), $t('integration.be_applied_to')]"
            filter-:placeholder="$t('integration.please_enter_the_customer_name')"
            v-model="choozeValue"
            :data="cusData"
            :props="propsOwn"
        >
        </el-transfer>
    </div>
</template>

<script>
export default {
    props: ['isMode', 'customers', 'detailContent'],
    watch: {
        customers(newVal) {
            this.cusData = [...newVal].slice(1);
        },
        detailContent(newVal) {
            this.appArray = [];
            newVal.carrierTypeApplyList.forEach(item => {
                this.customers.forEach(opt => {
                    if (String(item.sceneId) === opt.id) {
                        this.appArray.push(opt);
                    }
                });
            });
        },
        isMode(newVal) {
            this.choozeValue = this.appArray.map(item => item.id + '');
        }
    },
    data() {
        return {
            appArray: [],
            // consult
            pattern: 'edit',
            cusData: [],
            choozeValue: [],
            propsOwn: {
                key: 'id',
                label: 'name'
            }
        };
    },
    methods: {}
};
</script>

<style lang="scss" scoped>
.applocation {
    display: flex;
    flex-wrap: wrap;

    .app_content {
        width: 100px;
        height: 30px;
        padding: 0 5px;
        margin-right: 15px;
        margin-bottom: 15px;
        box-sizing: border-box;
        text-align: center;
        line-height: 30px;
        border-radius: 2px;
        color: #fff;
        background-color: var(--primary-color);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>
